import AuthService from '../services/auth.service'

export function authHeader () {
  return new Promise((resolve, reject) => {
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
    if (!user) {
      reject(new Error('user not found'))
      return
    }
    var t = new Date(user.createAt)
    t.setSeconds(t.getSeconds() + user.expiredIn)
    if (t >= new Date()) {
      resolve({ Authorization: 'Bearer ' + user.accessToken })
      return
    }
    user.userData = JSON.parse(user.userData)
    AuthService.login({ username: user.userData.userName, password: user.userData.passwordHash }).then(
      user => {
        resolve({ Authorization: 'Bearer ' + user.accessToken })
      },
      () => {
        reject(new Error('refresh token failed'))
      },
    )
  })
  // return authorization header with jwt token
}
